import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import CollectionsList from "../components/CollectionsList";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionsList);
const withTranslationComponent = withTranslation(["collectionsList", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/CollectionsList.js